import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { IconAbc, IconInfoCircle, IconPencil } from "@tabler/icons-react";
import { MODALS } from "../../helpers/constants";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const ChangeAlias = observer(({ cubby }: { cubby: Cubby }) => {
  const [newAlias, setNewAliasText] = useState(cubby.alias || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setNewAliasText(cubby.alias || "");
  }, [cubby.alias]);

  const handleSetAlias = () => {
    if (newAlias.length > 30) {
      setError("Alias cannot be more than 30 characters.");
    } else {
      setError("");
      cubby.setAlias(newAlias);
      cubby.setModal(null);
    }
  };

  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.CHANGE_ALIAS}
        onClose={() => cubby.setModal(MODALS.NODE_IDENTITY)}
        title={
          <TextWithInfoAndIcon
            text="Node Alias"
            articleSlug={ARTICLES.NODE_INFO_AND_ALIAS.slug}
            icon={<IconInfoCircle size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <Text>
            Setting a custom alias can reduce your privacy on the Lightning
            Network. If you open a public channels, your alias will be
            broadcasted to the network.
          </Text>
          <TextInput
            label="Modify Alias"
            placeholder="my alias"
            value={newAlias}
            onChange={(event) => setNewAliasText(event.currentTarget.value)}
            error={error}
            maxLength={30}
          />
          {error && <Text c="red">{error}</Text>}
          <Button variant="filled" color="blue" onClick={handleSetAlias}>
            Set Alias
          </Button>
          <Text>
            Alias changes may take several hours to propagate across the
            network.
          </Text>
        </Stack>
      </Modal>
    </>
  );
});

export default ChangeAlias;
